<script lang="ts" setup>
import type { HTMLAttributes } from "vue";
import { reactiveOmit } from "@vueuse/core";
import {
    RangeCalendarHeading,
    type RangeCalendarHeadingProps,
    useForwardProps,
} from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps<
    RangeCalendarHeadingProps & { class?: HTMLAttributes["class"] }
>();

defineSlots<{
    default: (props: { headingValue: string }) => any;
}>();

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarHeading
        v-slot="{ headingValue }"
        :class="cn('slt-body-1 font-en font-bold text-base-black', props.class)"
        v-bind="forwardedProps"
    >
        <slot :heading-value>
            {{ headingValue }}
        </slot>
    </RangeCalendarHeading>
</template>
